'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#060E1A] flex flex-col items-center justify-center p-6 text-center">
      {/* Background decoration */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.03]"
          style={{ background: 'radial-gradient(ellipse, #F97316 0%, transparent 70%)' }} />
      </div>

      <div className="relative max-w-md w-full page-transition">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#F97316]/10 border border-[#F97316]/20 flex items-center justify-center">
            <AppLogo size={40} />
          </div>
        </div>

        {/* 404 */}
        <div className="mb-6">
          <p className="text-8xl font-black text-[#F97316]/20 leading-none select-none" aria-hidden="true">404</p>
          <h1 className="text-xl sm:text-2xl font-bold text-white mt-2">Page not found</h1>
          <p className="text-zinc-500 text-sm mt-2 leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
            Please check the URL or navigate back to your dashboard.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/portal" className="btn-primary">
            <Home size={16} aria-hidden="true" />
            Go to Dashboard
          </Link>
          <Link href="/login" className="btn-secondary">
            <ArrowLeft size={16} aria-hidden="true" />
            Back to Login
          </Link>
        </div>

        <p className="text-[11px] text-zinc-700 mt-8">
          © iBrain LAB · CogniDash Platform
        </p>
      </div>
    </div>
  );
}